import { cn } from "@repo/lib";
import { Link } from "@tanstack/react-router";
import { motion } from "framer-motion";

interface FullScreenListOptionIconProps {
  children: JSX.Element;
  className?: string;
}

export const FullScreenListOptionIcon = ({
  children,
  className = "",
}: FullScreenListOptionIconProps): JSX.Element => {
  return (
    <motion.div
      className={cn("w-10 h-10 rounded-lg flex items-center justify-center", className)}
      whileTap={{
        scale: 0.9,
        backgroundColor: "#fed7aa",
      }}
    >
      {children}
    </motion.div>
  );
};

interface FullScreenListOptionTitleProps {
  children: string;
}

export const FullScreenListOptionTitle = ({
  children,
}: FullScreenListOptionTitleProps): JSX.Element => {
  return <h3 className="font-medium text-gray-900 text-md">{children}</h3>;
};

export const FullScreenListOptionList = ({
  children,
}: {
  children: JSX.Element | JSX.Element[];
}): JSX.Element => {
  return <motion.div className="flex flex-col gap-4 p-4">{children}</motion.div>;
};

interface FullScreenListOption {
  children: JSX.Element | JSX.Element[];
  index?: number;
  className?: string;
  route?: string;
  search?: object;
}

export const FullScreenListOption = ({
  children,
  index = 0,
  className = "",
  route,
  search,
}: FullScreenListOption): JSX.Element => {
  return (
    <Link to={route} search={search} replace>
      <motion.button
        className={cn(
          "w-full h-[60px] flex items-center gap-4 py-4 px-6 bg-white rounded-lg transition-colors text-left",
          className,
        )}
        initial={{ opacity: 0, x: -20, scale: 0.8 }}
        animate={{
          opacity: 1,
          x: 0,
          scale: 1,
          transition: {
            delay: index * 0.1,
            type: "spring",
            stiffness: 100,
            damping: 15,
          },
        }}
        whileTap={{
          scale: 0.96,
          transition: { duration: 0.1 },
        }}
      >
        {children}
      </motion.button>
    </Link>
  );
};
